import { useMultiSelectFilter } from '@/scopes/search/search/domain/hooks'
import { Token } from '@sunwebgroup/ui-components/uds'
import { equals, reject } from 'ramda'
import { useCallback } from 'react'

export function DiscountTokens() {
  const { isFetching, isLoading, selectedOptions, setSelection, selectedValues } = useMultiSelectFilter('Discount')

  const handleRemoveClick = useCallback(
    (value?: string) => {
      setSelection(reject(equals(value), selectedValues))
    },
    [selectedValues, setSelection],
  )

  if (isLoading)
    return null

  return selectedOptions.map(({ value, name }) => (
    <Token key={value} value={value} disabled={isFetching} dismissible onDismissClick={handleRemoveClick}>
      {name}
    </Token>
  ))
}

export function CampaignsTokens() {
  const { isFetching, isLoading, selectedOptions, setSelection, selectedValues } = useMultiSelectFilter('Campaigns')

  const handleRemoveClick = useCallback(
    (value?: string) => {
      setSelection(reject(equals(value), selectedValues))
    },
    [selectedValues, setSelection],
  )

  if (isLoading)
    return null

  return selectedOptions.map(({ value, name }) => (
    <Token key={value} value={value} disabled={isFetching} dismissible onDismissClick={handleRemoveClick}>
      {name}
    </Token>
  ))
}

export function CampaignsAndDiscountTokens() {
  const { isFetching, isLoading, selectedOptions, setSelection, selectedValues } = useMultiSelectFilter('CampaignsAndDiscounts')

  const handleRemoveClick = useCallback(
    (value?: string) => {
      setSelection(reject(equals(value), selectedValues))
    },
    [selectedValues, setSelection],
  )

  if (isLoading)
    return null

  return selectedOptions.map(({ value, name }) => (
    <Token key={value} value={value} disabled={isFetching} dismissible onDismissClick={handleRemoveClick}>
      {name}
    </Token>
  ))
}

export function DealTokens() {
  return (
    <>
      <DiscountTokens />
      <CampaignsTokens />
      <CampaignsAndDiscountTokens />
    </>
  )
}
